import React, { useEffect, useState, useMemo, useRef, useCallback } from "react";
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Typography,
  TextField,
  List,
  ListItem,
  ListItemText,
  Avatar,
  Menu,
  MenuItem,
  IconButton,
  Badge,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
} from "@mui/material";
import {
  Send as SendIcon,
  Block as BlockIcon,
  MoreVert as MoreVertIcon,
  Search as SearchIcon,
  Done as DoneIcon,
  Alarm as AlarmIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { useDispatch, useSelector } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import {
  getAllChatUserList,
  getSelectedUserChatAction,
  getUnreadCountAction,
  getUserCountAction,
  sendMessageAction,
  getMessageSearchAction,
  getAllSmsTemplatesAction
} from '../redux/actions/communicationAction';


const ChatPage = () => {
  const dispatch = useDispatch();
  const getuserlist = useSelector((state) => state.communication?.getAllUserListChat || []);
  const chat_count = useSelector((state) => state.communication?.user_chat_count.content || []);
  const selected_user_chat = useSelector((state) => state.communication?.selected_user_chat.content || []);  
  const sms_Templates = useSelector ((state)=> state.communication?.smsTemplates.content || []);
  const selected_customer = useSelector ((state)=> state.communication?.selected_customer || []);
   
  const [userlist, setUserList] = useState(getuserlist);
  const [userChat, setUserChat] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [filteredUsers, setFilteredUsers] = useState(getuserlist); 
  const [userFirstName, setUserFirstName] = useState(null);
  const [userLasttName, setUserLastName] = useState(null);
  const [userPhonenumber, setUserPhonenumber] = useState(null);
  const [open, setOpen] = useState(false);
  const [currentMessage, setCurrentMessage] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [allChatUsers, setAllChatUsers] = useState([getuserlist]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const listRef = useRef(null);
  const theme = useTheme();
  const PAGE_SIZE = 5;
    const [formValues, setFormValues] = useState({
      policyId: null,
      createdDate: null,
      policyNumber: null,
      closedDate: '',
      closedBy: '',
      taskTo: '',
      dueDate: null,
      status: '',
      taskDescription: '',
    });
  const mergeUniqueUsers = (existingUsers, newUsers) => {
    const uniqueUsers = [...existingUsers];
    newUsers.forEach(newUser => {
      const existingIndex = uniqueUsers.findIndex(
        existing => existing.fromPhoneNumber === newUser.fromPhoneNumber
      );
      if (existingIndex === -1) {
        uniqueUsers.push(newUser);
      } else {
        uniqueUsers[existingIndex] = newUser;
      }
    });
    return uniqueUsers;
  };

  useEffect(() => {
    setFilteredUsers(getuserlist); 
  }, [getuserlist]);
  const handleScroll = useCallback(async () => {
    if (!listRef.current || isLoading || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = listRef.current;
    const scrollPosition = scrollTop + clientHeight;
    const threshold = 100; 

    try {
      
      if (scrollHeight - scrollPosition < threshold) {
        setIsLoading(true);
        const nextPage = Math.ceil(allChatUsers.length / PAGE_SIZE);

        const response = await dispatch(getAllChatUserList(nextPage, PAGE_SIZE));
        const newUsers = response?.content || [];

        if (newUsers.length > 0) {
          setAllChatUsers(prevUsers => mergeUniqueUsers(prevUsers, newUsers));
          if (newUsers.length < PAGE_SIZE) {
            setHasMore(false);
          }
        } else {
          setHasMore(false);
        }
      }

      if (scrollTop < threshold && allChatUsers.length >= PAGE_SIZE) {
        setIsLoading(true);
        const prevPage = Math.floor((allChatUsers.length - PAGE_SIZE) / PAGE_SIZE);

        if (prevPage >= 0) {
          const response = await dispatch(getAllChatUserList(prevPage, PAGE_SIZE));
          const newUsers = response?.payload?.content || [];

          if (newUsers.length > 0) {
            setAllChatUsers(prevUsers => mergeUniqueUsers(newUsers, prevUsers));
          }
        }
      }
    } catch (error) {
      console.error('Error loading users:', error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, isLoading, hasMore, allChatUsers.length]);
  
  const debouncedScroll = useCallback(
    debounce((event) => handleScroll(event), 150),
    [handleScroll]
  );

  useEffect(() => {
    const loadInitialUsers = async () => {
      setIsLoading(true);
      try {
        const response = await dispatch(getAllChatUserList(0, PAGE_SIZE));
        
        const initialUsers = response?.content || [];
        setAllChatUsers(initialUsers);
        setHasMore(initialUsers.length === PAGE_SIZE);
      } catch (error) {
        console.error('Error loading initial users:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadInitialUsers();
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllSmsTemplatesAction());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getSelectedUserChatAction(selected_customer, callbackfn))     
  }, [dispatch, selected_customer]);
  

  useEffect(() => {
    const list = listRef.current;
    if (list) {
      list.addEventListener('scroll', debouncedScroll);
      return () => {
        list.removeEventListener('scroll', debouncedScroll);
        debouncedScroll.cancel();
      };
    }
  }, [debouncedScroll]);

  function debounce(func, wait) {
    let timeout;
    const debouncedFunction = function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
    debouncedFunction.cancel = function () {
      clearTimeout(timeout);
    };
    return debouncedFunction;
  }
  const updatedUserList = useMemo(() => {
    if (getuserlist.length === 0) return [];

    return getuserlist.map((user) => {
      const matchedUser = chat_count.find(
        (chat) => chat.phoneNumber === user.fromPhoneNumber
      );

      return {
        ...user,
        unreadCount: matchedUser ? matchedUser.unreadCount : 0,
        formattedDate: user.createdAt
          ? new Date(user.createdAt).toLocaleDateString()
          : "",
      };
    });
  }, [getuserlist, chat_count]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(getAllChatUserList(page, size));
      dispatch(getUserCountAction());
    }, 5000);
    return () => clearInterval(intervalId);
  }, [selectedUser, userChat, dispatch, page, size]);

  useEffect(() => {
    if (searchQuery.trim().length > 0) {
      const delayDebounceFn = setTimeout(() => {
        const encodedQuery = encodeURIComponent(searchQuery);
        dispatch(getMessageSearchAction(encodedQuery, callbackfn));
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchQuery, dispatch]);

  useEffect(() => {
    if (selectedUser) {
      dispatch(getSelectedUserChatAction(selectedUser));

      const intervalId = setInterval(() => {
        dispatch(getSelectedUserChatAction(selectedUser));
      }, 5000);

      return () => clearInterval(intervalId);
    }
  }, [selectedUser, userChat, dispatch]);

  useEffect(() => {
    if (selected_user_chat.length > 0) {
      setUserChat([...selected_user_chat].reverse()); 
    }
  }, [selected_user_chat]);

  useEffect(() => {
    if (JSON.stringify(userlist) !== JSON.stringify(updatedUserList)) {
      setUserList(updatedUserList);
    }
  }, [updatedUserList]);

  useEffect(() => {
    if (selected_customer) {
      const matchingUser = getuserlist.find(user => user.fromPhoneNumber === selected_customer);
      
      if (matchingUser) {
        setSelectedUser(matchingUser.fromPhoneNumber);
        setUserPhonenumber(matchingUser.fromPhoneNumber);
        setUserFirstName(matchingUser.firstName);
        setUserLastName(matchingUser.lastName);
        
        dispatch(getSelectedUserChatAction(matchingUser.fromPhoneNumber));
      }
    }
  }, [selected_customer, getuserlist, dispatch]);
  
  const handleModelClose = () => {
    setOpen(false);
    setFormValues({
      policyId: '',
      taskTo: '',
      dueDate: '',
      subject: '',
      status: '',
      taskDescription: ''
    });
  };

  const handleMessageChange = (e) => {
    const input = e.target.value;
    setCurrentMessage(input);
  
    if (!sms_Templates || !Array.isArray(sms_Templates)) {
      console.error("sms_Templates is not an array:", sms_Templates);
      setShowSuggestions(false);
      return;
    }
  
    if (input.length > 0) {
      const matches = sms_Templates
        .filter((template) => template.text && typeof template.text === "string")
        .filter((template) => template.text.toLowerCase().startsWith(input.toLowerCase()));
      setFilteredTemplates(matches);
      setShowSuggestions(matches.length > 0);
    } else {
      setShowSuggestions(false);
    }
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues(prevValues => ({
      ...prevValues,
      [name]: value
    }));
  };

  const handleSendMessage = () => {
    if (typeof currentMessage !== "string" || !currentMessage.trim() || !selectedUser) {
      console.warn("Invalid message or no user selected.");
      return;
    }
  
    const newMessage = {
      toPhoneNumber: "",
      messageBody: currentMessage,
    };
  
    dispatch(sendMessageAction(newMessage, (res) => {
      if (res?.status === "Success") {
        setUserChat((prevChat) => [
          ...prevChat,
          { ...newMessage, smsType: "SENT", createdAt: new Date().toISOString() },
        ]);
        dispatch(getSelectedUserChatAction(selectedUser, callbackfn));
      } else {
        console.error("Message failed to send", res);
      }
    }));
  
    setCurrentMessage(""); 
  };
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (value.trim().length > 0) {
      const filtered = getuserlist.filter(
        (user) =>
          user.firstName.toLowerCase().includes(value.toLowerCase()) ||
          user.lastName.toLowerCase().includes(value.toLowerCase()) ||
          user.fromPhoneNumber.includes(value)
      );

      setFilteredUsers(filtered);
    } else {
      setFilteredUsers(getuserlist); 
    }
  };

  const handleTemplateClick = (template) => {
    setCurrentMessage(template.text); 
    setShowSuggestions(false);
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "";
    const cleaned = phoneNumber.replace(/\D/g, "");
    const withoutCountryCode = cleaned.startsWith("1") && cleaned.length === 11
      ? cleaned.substring(1)
      : cleaned;
    return withoutCountryCode.replace(/^(\d{3})(\d{3})(\d{4})$/, "($1) $2-$3");
  };

  const formatChatTimestamp = (createdAt) => {
    const messageDate = new Date(createdAt);
    const today = new Date();

    const isToday =
      messageDate.getDate() === today.getDate() &&
      messageDate.getMonth() === today.getMonth() &&
      messageDate.getFullYear() === today.getFullYear();

    if (isToday) {
      return messageDate.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      });
    }
    return messageDate.toLocaleDateString();
  };

  const callbackfn = (res) => {
    const messages = res.content.map((sms) => sms);
    const unreadMessageIds = messages
      .filter((msg) => msg.read === false)
      .map((msg) => msg.id);

    if (unreadMessageIds.length > 0) {
      dispatch(getUnreadCountAction(unreadMessageIds));
    }
  };

  const getChatUserId = (contact, f_name, l_name, user_number) => {
    setUserPhonenumber(formatPhoneNumber(user_number));
    setUserFirstName(f_name);
    setUserLastName(l_name);
    setSelectedUser(contact);
    dispatch(getSelectedUserChatAction(contact, callbackfn));
  };
  
  return (
    <Box sx={{
      margin: "0 auto",
      padding: "15px",
      overflow: "hidden",
      backgroundColor: "#f9f9f9",
      height: "90vh",
    }}>
      <Box sx={{
        display: "flex",
        flexDirection: "row",
        height: "90%",
        backgroundColor: "#f9f9f9",
        border: "1px solid #ddd",
        borderRadius: "16px 16px 8px 16px",
      }}>
        <Box sx={{
          width: "25%",
          backgroundColor: "#fff",
          borderRight: "1px solid #ddd",
          display: "flex",
          flexDirection: "column",
        }}>
          <Box sx={{
            padding: "16px",
            backgroundColor: "#ffffff",
            color: "#000",
            borderBottom: "1px solid #ddd",
          }}>
            <Typography variant="h6" sx={{ fontWeight: "500" }}>
              Conversations
            </Typography>
          </Box>

          <TextField
            variant="outlined"
            size="small"
            placeholder="Search Messages..."
            value={searchQuery}
            onChange={handleSearchChange}
            sx={{
              margin: "16px 16px",
              "& .MuiOutlinedInput-root": {
                backgroundColor: "#f7f7f7",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ marginRight: "8px", color: "#999" }} />
                </InputAdornment>
              ),
              endAdornment: searchQuery.length > 0 && (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      setSearchQuery("");
                      dispatch(getAllChatUserList(page, size));
                    }}
                    edge="end"
                  >
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <List ref={listRef} sx={{ overflowY: "auto", flex: 1 }}>
            {filteredUsers.map((contact, index) => (
              <ListItem
                button
                key={index}
                onClick={() =>
                getChatUserId(
                  contact.fromPhoneNumber,
                  contact.firstName,
                  contact.lastName,
                  )
                }
                sx={{
                  backgroundColor:
                    selectedUser === contact.fromPhoneNumber ? theme.palette.primary.main : "#fff",
                  borderBottom: "1px solid #ddd",
                  transition: "background-color 0.3s ease",
                  "&:hover": { backgroundColor: "#f1f1f1" },
                }}
              >
              <Avatar
                sx={{
                  marginRight: "8px",
                  backgroundColor: "#FFF4DB",
                  color: "#000",
                  border: `1px solid ${theme.palette.primary.main}`,
                }}
              >
                {contact?.firstName?.charAt(0)}
                {contact?.lastName?.charAt(0)}
              </Avatar>

              <ListItemText
                primary={
                  <Typography variant="body1" sx={{ fontWeight: "500", fontSize: "14px" }}>
                    {contact.firstName} {contact.lastName} {` `}
                    {formatPhoneNumber(contact.fromPhoneNumber)}
                  </Typography>
                }
                secondary={contact.message}
              />

                <Box
                  sx={{
                    display: "flex",
                    flexFlow: "column",
                    justifyContent: "end",
                    alignItems: "end",
                  }}
                >
                  <Typography variant="caption" sx={{ color: "#000000", display: "block" }}>
                    {contact.formattedDate}
                  </Typography>
                  <Box sx={{ margin: "5px 0" }}>
                    {contact.unreadCount > 0 && (
                      <Badge badgeContent={contact.unreadCount} color="error" sx={{ marginRight: "8px" }} />
                    )}
                  </Box>
                </Box>
              </ListItem>
            ))}
          </List>
        </Box>

        <Box sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fff",
        }}>
          <Box sx={{
            padding: "16px",
            backgroundColor: "#ffffff",
            color: "#000",
            borderBottom: "1px solid #ddd",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}>
            <Avatar sx={{
              backgroundColor: "#FFF4DB",
              color: "#000",
              border: `1px solid ${theme.palette.primary.main}`,
            }}>
              {userFirstName && userLasttName ? (
                `${userFirstName?.charAt(0)}${userLasttName?.charAt(0)}`
              ) : (
                userPhonenumber
              )}
            </Avatar>
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              {userFirstName && userLasttName ? `${userFirstName} ${userLasttName}` : userPhonenumber}
            </Typography>
          </Box>

          <Box sx={{
            flex: 1,
            padding: "16px",
            overflowY: "auto",
            backgroundColor: "#f9f9f9",
          }}>
            {[...selected_user_chat].reverse().map((message, index) => (
              message.smsType === "SENT" ? (
                <Box key={index} sx={{
                  margin: "8px 0",
                  display: "flex",
                  flexFlow: "column",
                  alignItems: "flex-end",
                  gap: 1,
                }}>
                  <Box sx={{ display: "flex", alignItems: 'center', margin: '0 0 10px 0' }}>
                    <Box>
                      <Box sx={{
                        backgroundColor: "#fff",
                        color: "#000",
                        padding: "4px 10px",
                        borderRadius: "12px",
                        maxWidth: "100%",
                        border: '1px solid #ddd',
                        margin: '10px 0 0 0'
                      }}>
                        <Typography variant="body1" sx={{ fontSize: '13px' }}>
                          {message.message}
                        </Typography>
                      </Box>
                      <Typography variant="caption" sx={{ marginTop: "4px", color: "#999" }}>
                        {formatChatTimestamp(message.createdAt)}
                      </Typography>
                    </Box>
                    <Avatar sx={{
                      backgroundColor: `${theme.palette.primary.main}`,
                      color: "#fff",
                      border: "1px solid #ccc",
                      margin: '0 10px'
                    }}>
                      {message.userIcon}
                    </Avatar>
                  </Box>
                </Box>
              ) : (
                <Box key={index} sx={{
                  margin: "8px 0",
                  display: "flex",
                  flexFlow: "column",
                  gap: 1
                }}>
                  <Box sx={{ display: "flex", alignItems: 'center' }}>
                    <Avatar sx={{
                      backgroundColor: `${theme.palette.primary.main}`,
                      color: "#000",
                      margin: '0 10px',
                      border: `1px solid ${theme.palette.primary.main}`
                    }}>
                      {message?.firstName?.charAt(0)}{message?.lastName?.charAt(0)}
                    </Avatar>
                    <Box>
                      <Box sx={{ fontSize: '12px' }}>{message.firstName}</Box>
                      <Box sx={{
                        backgroundColor: "#f5f5f5",
                        color: "#000",
                        border: '1px solid #ddd',
                        padding: "5px 10px",
                        borderRadius: "12px",
                        maxWidth: "100%"
                      }}>
                        <Typography sx={{ fontSize: '13px' }} variant="body1">
                          {message.message}
                        </Typography>
                      </Box>
                      <Typography variant="caption" sx={{
                        marginTop: "4px",
                        color: "#999",
                        fontSize: '12px'
                      }}>
                        {formatChatTimestamp(message.createdAt)}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )
            ))}
          </Box>

          <Box sx={{
            padding: "16px",
            borderTop: "1px solid #ddd",
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
          }}>
            <Box sx={{ position: "relative", width: "100%" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                multiline
                minRows={2}
                maxRows={4}
                placeholder="Type a message..."
                value={currentMessage}
                onChange={handleMessageChange}
                error={currentMessage.length > 250}
                helperText={
                  currentMessage.length > 250
                    ? "Message cannot exceed 250 characters!"
                    : `${currentMessage.length}/250`
                }
                sx={{
                  marginRight: "8px",
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#f7f7f7",
                  },
                }}
              />
              {showSuggestions && (
                <Box
                  sx={{
                    position: "absolute",
                    bottom: "100%",
                    left: 0,
                    right: 0,
                    backgroundColor: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    maxHeight: "150px",
                    overflowY: "auto",
                    zIndex: 10,
                  }}
                >
                  {filteredTemplates.map((template, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => handleTemplateClick(template)}
                      sx={{
                        background: '#f7f7f7',
                        border: '#ccc solid 1px',
                        borderRadius: '5px',
                        margin: '10px',
                        fontSize: '12px',
                        padding: '4px 15px',
                        display: 'inline-flex',
                        "&:hover": { backgroundColor: "#f1f1f1" },
                        cursor: "pointer",
                      }}
                    >
                      {template.text} 
                    </MenuItem>
                  ))}
                </Box>
              )}
            </Box>

            <IconButton
              aria-controls="message-menu"
              aria-haspopup="true"
              onClick={handleClick}
              sx={{ color: "#999", marginRight: "8px" }}
            >
              <MoreVertIcon />
            </IconButton>

            <Menu
              id="message-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>
                <BlockIcon sx={{ marginRight: "8px" }} />
                No action need
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <DoneIcon sx={{ marginRight: "8px", color: "#4caf50" }} />
                Complete
              </MenuItem>
              <MenuItem onClick={() => {
                setOpen(true);
                handleClose();
              }}>
                <AlarmIcon sx={{ marginRight: "8px", color: "#ff9800" }} />
                Reminder
              </MenuItem>
            </Menu>

            <Button
              variant="contained"
              endIcon={<SendIcon />}
              onClick={handleSendMessage}
              disabled={!currentMessage || typeof currentMessage !== "string" || !currentMessage.trim() || currentMessage.length > 250}
           
            >
              Send
            </Button>
          </Box>
        </Box>
      </Box>

      <Dialog open={open} onClose={handleModelClose} maxWidth="md" fullWidth>
        <DialogTitle className="btn-primary" sx={{
          height: '64px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 16px',
          
        }}>
          Add Task
        </DialogTitle>

        <DialogContent>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }}>
            <Box sx={{ width: '23%' }}>
              <Typography variant="body1" sx={{ mb: 1 }}>Assigned To</Typography>
              <TextField
                select
                fullWidth
                name="taskTo"
                value={formValues.taskTo}
                onChange={handleChange}
                variant="outlined"
              >
                <MenuItem value="" disabled>Select Assign To</MenuItem>
                <MenuItem value="MICHELLE MIRABAL">MICHELLE MIRABAL</MenuItem>
                <MenuItem value="Alan">Alan</MenuItem>
                <MenuItem value="Sahil">Sahil</MenuItem>
                <MenuItem value="Sanjeev">Sanjeev</MenuItem>
              </TextField>
            </Box>

            <Box sx={{ width: '23%' }}>
              <Typography variant="body1" sx={{ mb: 1 }}>Due Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={formValues.dueDate ? dayjs(formValues.dueDate) : null}
                  onChange={(newValue) => handleChange({
                    target: { name: 'dueDate', value: newValue }
                  })}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  minDate={dayjs()}
                />
              </LocalizationProvider>
            </Box>

            <Box sx={{ width: '23%' }}>
              <Typography variant="body1" sx={{ mb: 1 }}>Status</Typography>
              <TextField
                select
                fullWidth
                name="status"
                value={formValues.status}
                onChange={handleChange}
                variant="outlined"
              >
                <MenuItem value="" disabled>Select Status</MenuItem>
                <MenuItem value="Open">Open</MenuItem>
                <MenuItem value="Close">Close</MenuItem>
              </TextField>
            </Box>

            <Box sx={{ width: '23%' }}>
              <Typography variant="body1" sx={{ mb: 1 }}>Closed Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={formValues.closedDate ? dayjs(formValues.closedDate) : null}
                  onChange={(newValue) => handleChange({
                    target: { name: 'closedDate', value: newValue }
                  })}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  minDate={dayjs()}
                />
              </LocalizationProvider>
            </Box>

            <Box sx={{ width: '23%' }}>
              <Typography variant="body1" sx={{ mb: 1 }}>Closed By</Typography>
              <TextField
                select
                fullWidth
                name="closedBy"
                value={formValues.closedBy}
                onChange={handleChange}
                variant="outlined"
              >
                <MenuItem value="" disabled>Select</MenuItem>
                <MenuItem value="MICHELLE MIRABAL">MICHELLE MIRABAL</MenuItem>
                <MenuItem value="Alan">Alan</MenuItem>
                <MenuItem value="Sahil">Sahil</MenuItem>
                <MenuItem value="Sanjeev">Sanjeev</MenuItem>
              </TextField>
            </Box>

            <Box sx={{ width: '98%' }}>
              <Typography variant="body1" sx={{ mb: 1 }}>Task Description</Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                name="taskDescription"
                value={formValues.taskDescription}
                onChange={handleChange}
                variant="outlined"
              />
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ padding: '16px' }}>
          <Button
            onClick={handleModelClose}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ChatPage;